const slick = require('slick-carousel');
if ($('.homepage-banner').length) {
    $('.homepage-banner').slick({
        autoplay: true,
        speed: 800,
        lazyLoad: 'progressive',
        arrows: false,
        dots: true,
        pauseOnHover: false,
    }).slickAnimation();

}

$('.slider').slick({
    autoplay: true,
    speed: 800,
    lazyLoad: 'progressive',
    arrows: false,
    dots: true,
}).slickAnimation();


// console.log($('.cd-auto-hide-header').innerHeight());

$('.homepage-banner').css({
    'height': 'calc(100vh - ' + $('.cd-auto-hide-header').innerHeight() + 'px)'
});

if ($('.news-events-slick').length) {
    // News & Events slick
    $('.news-events-slick').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true
                }
            }

        ]
    });
}


if ($('.news-events-details-garelly').length) {
    // News & Events details slick
    $('.news-events-details-garelly').slick({
        infinite: false,
        speed: 300,
        dots: true,
        fade: true,
        responsive: [{
            breakpoint: 597,
            settings: {
                arrows: false,
                dots: true
            }
        }]
    });
}

// Modal Not Registered

if ($('.not-registered').length) {
    $('.not-registered').click(function(e) {
        e.preventDefault();
        $('#ModalNotRegistered').modal('show');
    });

}


if ($('.slick-row').length) {
    $('.slick-row').slick({
        infinite: false,
        lazyLoad: 'progressive',
        rows: 2,
        slidesToShow: 6,
        dots: true,
        arrows: false,
        responsive: [{
                breakpoint: 1500,
                settings: {
                    slidesToShow: 5,
                }
            }, {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4,
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }

        ]
    });
}

if ($('.family-slick-row').length) {
    $('.family-slick-row').slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 6,
        responsive: [{
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4,

                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }

        ]
    });
}
$('.nav-products .nav-link').click(function() {
    setTimeout(function() {
        $('.family-slick-row').slick('reinit');
        $('.slick-row').slick('reinit');

        // alert('Done')
    }, 300);

});